import { bluePalette } from '../../../themes/colors';

export const secondarySidenavDarkTheme = {
  backgroundColor: bluePalette[1000],
};
